import { render } from "./QuickMatrixCard3.vue?vue&type=template&id=2656d0fb&scoped=true"
const script = {}

import "./QuickMatrixCard3.vue?vue&type=style&index=0&id=2656d0fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2656d0fb"]])

export default __exports__